module.exports = __webpack_public_path__ + "static/media/goodnest1_preview.7e40031f.jpg";